import { Checkbox } from 'antd';
import * as React from "react";
import './StyledCheckBox.styles.less';
import { IStyledCheckBoxProps } from "./StyledCheckBox.types";

export const StyledCheckBox = (props:IStyledCheckBoxProps) => {
    const {children, ...rest} = props;

    return (
        <Checkbox.Group className={'styled-checkbox-wrapper--checkbox'} {...rest}>
            {children}
        </Checkbox.Group>
    );
}